module.exports = __webpack_public_path__ + "static/Amiad-small-59b14a44cf445a7f20c0bcd1805b30fc.png";